// - [ ] Pixel Events
<template>
<div id="bulb-controls" style="height:100%;" >
	<resize-observer @notify="windowResize" />
	<div
		v-if="!isBroadcast && !isLiveSession || (isBroadcast && user.userType === 'teacher')"
		v-show='!bulbInitialized'
		:id = "(isBroadcast && user.userType === 'teacher') ? 'mimic-broadcast-teacher' : 'mimic'"
		class="grey darken-4"
		style="height:100% "
		:class="{ 'd-none': exposeYouTubeControls }">
			<div id="player-thumbnail"  :style="playerThumbnailStyle"></div>
			<v-container id="player-mimic" v-show="bulb" fill-height class='align-content-center'
				@click='initializePlay'
				@keyup.enter='initializePlay'
				@keyup.space='initializePlay'>
			  <v-layout row class='align-center'>
			    <v-flex xs12 class='text-xs-center'>
			    	<div v-if="showEntryCard">
			    			<v-card
			    			class="mx-auto enterLesson"
    						max-width="344"
    						>
			    				<v-card-title class="justify-center">
			    					<span class="title font-weight-light">Now Entering Lesson</span>
			    				</v-card-title>
			    				<v-card-text class="font-regular">Please click below when you are ready to begin.</v-card-text>
			    				<v-card-actions class="justify-center">
			    					<v-btn
											id="initialize-play-yt"
											@click="playButtonClick()"
											color="primary"
											role='button'
											aria-label='Start playback'
											:loading="initializingBulb">
			    						Begin
			    					</v-btn>
			    				</v-card-actions>
			    			</v-card>
			    	</div>
						<v-btn
							v-else
							:large="sidebarStyle !== 'portrait'"
							id="initialize-play"
							color="primary"
							role='button'
							aria-label='Start playback'
							:loading="initializingBulb"
							@click="playButtonClick()"
							column>
							<v-icon color="white">play_arrow</v-icon>
						</v-btn>
						<!-- Leaving this in here, because we mgiht use it later. -->
						<!-- <div
							v-if="isVimeoPasswordProtectedVideo"
							class="vimeo-password-protected-wrapper"
							:class="[
								sidebarStyle, 
								mobile ? 'mobile' : ''
							]"
							@click="playButtonClick()">
							<div id="password-protected-vimeo-video"></div>
						</div> -->
			    </v-flex>
			  </v-layout>
			</v-container>
	</div>
	
	<div id='liveSessionMimic' v-if="isLiveSession" v-show="startTimeDifference > 0 || !sessionClicked">
		<div id="liveSessionThumbnail"  :style="playerThumbnailStyle"></div>
			<v-container
			fill-height
			class='align-content-center'>
    		<v-card
					class="mx-auto enterLesson"
					max-width="344"
					v-if="!sessionClicked"
					:color="branding.activeColor"
					dark
					>
					<v-card-title class="justify-center">
						<span class="title font-weight-light">Entering Virtual Classroom</span>
					</v-card-title>
					<v-card-text
						class="font-regular"
						role="alert">
						{{sessionEntryText}}
					</v-card-text>
					<v-card-actions class="justify-center">
						<v-btn
							id="enterSessionButton"
							color="white"
							light
							role='button'
							aria-label='Enter session.'
							:loading="initializingBulb || bulbInitialized"
							@click="handleEnterSession"
							@keyup.enter='handleEnterSession'
							@keyup.space='handleEnterSession'>
  						Enter Virtual Classroom
  					</v-btn>
					</v-card-actions>
				</v-card>
				<v-card
					class="mx-auto enterLesson"
					max-width="400"
					v-else-if="startTimeDifference >= 0"
					:color="branding.activeColor"
					dark
					>
					<span
			      :class="{ hideAriaLabel: hideLabel }"
			      role="alert"
			      :aria-label="timeUntilStartAriaLabel"></span>
					<v-card-title class="justify-center">
						<span class="title font-weight-light" v-if="startTimeDifference > 0">{{startTimeDifference > 60 ? timeRemainingUntilStart : 'Class will start in'}}</span>
						<span v-else class="title font-weight-light">Session starting now...</span>
					</v-card-title>
					<v-card-text>
						<div v-if="startTimeDifference <= 60" class="title font-weight-light text-xs-center">
							{{startTimeDifference}} seconds
						</div>
					</v-card-text>
				</v-card>
			</v-container>
	</div>
	
		<!-- settings menu dialog tooltip -->
		<span
			id="settings-menu-dialog-tooltip"
			ref="settingsMenuDialogTooltip"
			:class="[sidebarStyle, mobile ? 'mobile' : '']">
		</span>
		<!-- Main player-contaienr -->
		<div
			id="player-container"
			:aria-hidden="!bulbInitialized"
			role="main"
			aria-label="player"
			@mousemove="handlePlayerContainerMousemoveEvent"
			:class="[
				sidebarStyle, 
				mobile ? 'mobile' : '',
				sidezoneOpen ? 'sidezone-open' : '',
				!bulbInitialized ? 'uninitialized' : '',
				sidebarOpen ? 'sidepanel-open' : '',
				isBroadcastTeacher ? 'broadcast--teacher' : '',
				isBroadcastStudent ? 'broadcast--student' : '',
				!bulbInitialized && !exposeYouTubeControls && !isBroadcast ? 'hidePlayerContainer' : '',
				exposeYouTubeControls ? 'exposeYouTubeControls' : '',
			]">
			<nav-margin
				ref="navMargin"
				:sidebarStyle="sidebarStyle"
				:class="{
					'd-none': (
						exposeYouTubeControls
						&& !isBroadcastTeacher
					)
				}"
				role="region"
				aria-label="navigation margin">
			</nav-margin>
			<SidebarPanel
				ref="sideBarPanel"
				:sidebarStyle="sidebarStyle"
				:class="{
					'd-none': (
						exposeYouTubeControls
						&& !isBroadcastTeacher
					)
				}"
				role="region"
				aria-label="sidebar panel">
			</SidebarPanel>
		<!-- video-container -->
		<div
			id="video-container"
			ref="videoContainer"
			class="split split-horizontal black "
			v-bind:class="[sidebarStyle == 'landscape'  ? 'allow-overlay' : '']">
			<div
				id='posit-wrapper'
				:class="{'small-aspect-ratio': smallAspectRatio }"
				ref="positWrapper">
				<canvas v-if="!mobile" id="player-confetti-container"></canvas>
				<overlay-container
					ref="playerOverlayContainer"
					:class="{
						'd-none': exposeYouTubeControls,
					}"
				>
				</overlay-container>
				<video-instance
					v-for="(bulbVideo, index) in bulb.bulbVideos"
					ref='videoInstance'
					:bulbVideo='bulbVideo'
					:index='index'
					:key='bulbVideo.id'
					:class="{ hideVideoInstance: exposeYouTubeControls && index > 0 }">
				</video-instance>
				<!--
					This should only ever show up on mobileIOS devices that are viewing a Panopto video using the Panopto
					embed api.
				 -->
				<div
					v-if="mobileIOS && hidePlayerControlsOnMobileIOSForPanopto"
					id="panopto-mobileIOS-information-icon"
					@click="redirectUserToPanoptoKbHelpArticle()">
					<v-icon color="primary" size="36">info</v-icon>
				</div>
				<div v-show='displayDuration === displayTime' class="no-current" ></div>
			</div>
		</div>
		<!-- End video-container -->

		<!-- controls-wrapper -->
	<div
		id="controls-wrapper"
		ref="controlsWrapper"
		v-show="!ytInitializing && (!isBroadcast || (isBroadcast && user.userType === 'teacher'))"
		:class="{
			'd-none':exposeYouTubeControls
			|| hidePlayControlsForVimeo
			|| hidePlayControlsForPanopto
			|| hidePlayerControlsOnMobileIOSForPanopto
		}"
		role="region"
		aria-label="Video controls">
			<!-- Play / Pause button -->
			<Tooltip
				v-if="!bulbFinished"
				top
				:delay-time="0"
			>
				<v-btn
					v-if="!bulbFinished"
					id="play-pause"
					flat
					icon
					class="ma-0"
					:aria-label="(playerState === 'play' ? 'Pause' : 'Play' ) + ` ${termForBulb.capitalize()}`"
					@click="togglePlayPause()"
					:disabled="isLiveSession">
					<v-icon color="white">
						{{ playerState === 'play' ? 'pause' : 'play_arrow' }}
					</v-icon>
				</v-btn>
				<template v-slot:text>
					{{ playerState === 'play' ? 'Pause' : 'Play' }}
				</template>
			</Tooltip>
			<!-- Replay button -->
			<Tooltip
				v-if="showReplayButton"
				top
				:delay-time="0">
				<v-btn
					v-if="showReplayButton"
					id="bulb-replay"
					flat
					icon
					class="ma-0"
					:aria-label="`Replay ${termForBulb.capitalize()}`"
					@click="replayVideo()">
					<v-icon color="white">replay</v-icon>
				</v-btn>
				<template v-slot:text>
					Replay
				</template>
			</Tooltip>
			<!-- Toggle Sidebar -->
			<Tooltip
				v-if="sidebarStyle !== 'portrait'"
				top
				:delay-time="0">
				<v-btn
					v-if="sidebarStyle !== 'portrait'"
					id='toggle-sidebar'
					flat
					icon
					class='white-text'
					@click="toggleSidezone()"
					:aria-label="(sidezoneOpen ? 'Close' : 'Open') + ' Sidebar'">
					<v-icon class="flip-vertically" :color="(sidebarOpen) ? 'primary' : 'white'">chrome_reader_mode</v-icon>
				</v-btn>
				<template v-slot:text>
					Toggle Sidezone
				</template>
			</Tooltip>
			<!-- 10 seconds rewind -->
			<Tooltip
				v-if="!isLiveSession"
				top
				:delay-time="0">
				<v-btn
					v-if="!isLiveSession"
					id="rewind-10"
					flat
					icon
					class="control-wrapper-icon"
					@click="seek(Math.max(displayTime - 10, 0))"
					aria-label="Seek back 10 seconds">
					<v-icon :color="(sidebarOpen) ? 'primary' : 'white'" >replay_10</v-icon >
				</v-btn>
				<template v-slot:text>
					Rewind 10 seconds
				</template>
			</Tooltip>
			<!-- 10 seconds forward -->
			<Tooltip
				v-if="!isLiveSession"
				top
				:delay-time="0">
				<v-btn
					v-if="!isLiveSession"
					id="forward-10"
					flat
					icon
					class="control-wrapper-icon"
					@click="seek(Math.min((displayTime + 10), displayDuration))"
					aria-label="Fast forward 10 seconds">
					<v-icon :color="(sidebarOpen) ? 'primary' : 'white'" >forward_10</v-icon >
				</v-btn>
				<template v-slot:text>
					Fast foward 10 seconds
				</template>
			</Tooltip>
			<!--Scrub Bar-->
			<ScrubBar />
			<div id="extra-actions-wrapper">
				<Tooltip
					v-if="(
						bulbHasCaptions
						&& !captionsDisabledTranscriptEnabled
					)"
					top
					:delay-time="0">
					<v-btn
						v-if="bulbHasCaptions"
						id="bulb-closed-captions"
						icon
						@click="toggleCC()"
						aria-label="closed captions">
						<v-icon
							:color="(ccOn) ? activePlayerIconColor : (sidebarStyle === 'portrait') ? 'grey darken-3' : 'white'">
							closed_caption
						</v-icon>
					</v-btn>
					<template v-slot:text>
						Subtitles/closed captions
					</template>
				</Tooltip>
				<Tooltip
					v-if="!mobileIOS"
					top
					:delay-time="0">
					<v-btn
						v-if="!mobileIOS"
						id="bulb-fullscreen"
						icon
						@click="toggleFullScreen"
						aria-label="toggle fullscreen">
						<v-icon
							:color="(isFullScreen) ? activePlayerIconColor : (sidebarStyle === 'portrait') ? 'grey darken-3' : 'white'">
							{{ fullScreenIcon }}
						</v-icon>
					</v-btn>
					<template v-slot:text>
						{{ fullScreenIcon === 'fullscreen' ? 'Full screen' : 'Exit full screen' }}
					</template>
				</Tooltip>
				<Tooltip
					top
					:delay-time="0">
					<v-dialog
						v-model="menu"
						content-class="settings-menu"
						hide-overlay
						scrollable
						attach="#settings-menu-dialog-tooltip">
						<v-btn
							id="toggle-settings"
							icon
							slot='activator'
							ref="settingsToggle"
							aria-label="Settings menu"
							@click="setupSettingsDialog">
							<v-icon
								:color="(settingsMenu) ? activePlayerIconColor : (sidebarStyle === 'portrait') ? 'grey darken-3' : 'white'">
								settings
							</v-icon>
						</v-btn>
						<settings ref='settings' aria-label="Settings menu"></settings>
					</v-dialog>
					<template v-slot:text>
						Settings
					</template>
				</Tooltip>
			</div>
		</div>
		<!-- End controls-wrapper -->

	</div> <!-- end show content wrapper -->
</div>
</template>
<script>
/* eslint-disable */

// Components
import EventBus from '@/buses/EventBus';
import NavMargin from './NavMargin';
import OverlayContainer from './OverlayContainer';
import Settings from './settings/Settings';
import SidebarPanel from './sidebar/SidebarPanel'
import VideoInstance from './VideoInstance';
import ScrubBar from './Scrubbar';

// Services
import PlayerService from '../services/PlayerService';
import XApiService from '@/services/XApiService';
// ! Deprecated: Do we need this anymore?
// import CaliperService from '../services/CaliperService';

// Global Mixin(s):
import LottieAnimation from '@mixins/LottieAnimation/LottieAnimation.js';

// Plugins / Libraries
import _ from 'lodash';
import { BroadcastChannel } from 'broadcast-channel';
import {
	PlayPositBroadcastChannels,
	PlayPositBroadcastChannelEventNames,
} from '@BroadcastChannels';
import moment from 'moment';


import {
	mapActions,
	mapGetters,
	mapMutations,
	mapState,
} from 'vuex';

// Lottie animations:
import vimeoPasswordAnimation from '@/assets/lottie-animations/password.json';

// --- BROADCAST CODE STARTS
import {
	getCurrentInteractionFromFirestore,
	listenBroadcastEvents,
	triggerInstructorStatus,
	triggerInteractionItems,
	triggerLearnerStatus,
} from '@/js/firestore-utils';
// --- BROADCAST CODE ENDS

export default {
  name: 'bulb-controls',
  components: {
		NavMargin,
		OverlayContainer,
		Settings,
		SidebarPanel,
		VideoInstance,
		ScrubBar,
  },
  data() {
		return {
			activeIds: [],
			activePlayerIconColor: '#2196f3',
			bulbControlsBroadcastChannel: null,
			concurrentRange: .026,
			hideLabel: false,
			inactivityTimer: null,
			liveSessionInterval: null,
			liveSessionTimeUpdateDifference: 0,
			log: null,
			m: moment,
			positWrapperMousemoveTimeout: null,
			randomTimeUpdateVar: Math.floor(90 + Math.random() * 30),
			reachedMaxTime: false,
			roundTime: 0,
			sessionFrameId: null,
			sessionTimeLoopStarted: false,
			startTimeDifference: 0,
			timeRemainingUntilStart: '',
			timeUntilStartAriaLabel: '',
			updatedViewCount: false,
		};
  },
	// mixins: [ LottieAnimation ],
  computed: {
  	...mapState('player', [
      'activeVideoInstanceIndex',
      'bulbCompleteTab',
  		'ccOn',
      'hideCaptionsEnableTranscript',
  		'isFullScreen',
  		'isLiveSession',
			'isPanoptoEmbeddedIframe',
  		'liveSessionStartTime',
  		'liveSessionUnixTime',
  		'liveSessionTimeArray',
  		'localUnixTimeOffset',
			'playerControlsDisplayType',
  		'youTubePlayClicked',
  		'screenfull',
  		'sessionClicked',
  		'sessionId',
  		'setFirstFocus',
  		'studentSubmissionId',
  		'playbackModeToggled',
			'playButtonClicked', // indication if the user has explicitly clicked our videojs player big blue play button.
			'slider', // reference to our players scrubbar
			'lti13Launch',
			'lmsIssuer',
  	]),
  	...mapGetters('adaptive', [
  		'segment_complexity',
  	]), // adaptive vuex
  	...mapGetters('player', [
  		'hasRubric',
  		'lmbTeacherAttempt',
  		'isLmb',
			'isPeerReview',
			// --- BROADCAST CODE STARTS
			'broadcastId',
			'broadcastActiveInteractionId',
			'broadcastLearners',
			'broadcastDisplayTime',
			'broadcastTeacherStatus',
			'isBroadcast',
			'isBroadcastTeacher',
			'isBroadcastStudent',
			// -- BROADCAST CODE ENDS
    	'allowRewind',
    	'branding',
  		'bulb',
  		'bulbAttempt',
  		'bulbFinished',
  		'bulbInitialized',
  		'desiredState',
  		'displayDuration',
  		'displayTime',
  		'displayTimeStart',
  		'duration',
  		'exposeYouTubeControls',
			'fullScreenIcon',
			'hasNewInteractionDisplayAccess',
			'hidePlayControlsForVimeo',
			'hidePlayControlsForPanopto',
			'hidePlayerControlsOnMobileIOSForPanopto',
  		'groupFuzz',
  		'initializingBulb',
  		'interactionRequest',
  		'isPlaylist',
  		'lookaround',
  		'maxTime',
			'mobileIOS',
  		'playerState',
  		'queryParams',
  		'requiredMaxTime',
  		'sessionStartTime',
  		'screenRatio',
  		'screenWidth',
  		'scrubbing',
  		'user',
  		'minSidebarPercent',
  		'minSidebarPx',
			'mobile',
			'runtime',
			'showInteractionsTab',
			'sidebarOpen',
			'sidebarStyle',
			'sidebarWidth',
	    'sidezoneOpen',
	    'slideInteraction',
			'settingsMenu',
			'tokenRefresh',
			'userAgent',
			'ytInitializing', // Duct tape for youtube in iframes not responding to user clicks. Iframe owner needs to add allow="autoplay *;"
			'vimeoInitializing',
			'vimeoInitialized',
			'panoptoInitialized',
			'termForBulb',
  	]),
		...mapGetters('interactions', [
			'activeInteraction',
			'activeInteractionGroup',
			'activeInteractionMeta',
			'activeOverlayInteractions',
			'hasRequiredInteractions',
			'interactions',
			'interactionGroups',
			'interactionMetas',
			'interactionStates',
			'interactionStateById',
			'requiredInteractionIndex',
			'rubricSubmitted',
		]),
		isBulbCheckoutEnabled() {
			return (
				_.get(this, 'bulb.config.checkout.enabled')
				&& this.queryParams.get('type') === 'bulb'
				&& !!this.user.token
				&& this.user.userType === 'student'
			);
		},
		isSchoolUser() {
			return _.get(this, 'bulb.teachers[0].school.id', false);
		},
		sessionEntryText() {
			if (this.startTimeDifference <= 0) return 'The class has already started.  Click below to join now.';
			return 'The class will start soon.  Click below to enter the waiting area.';
		},
    showEntryCard() {
      return (
        _.get(this, 'bulb.teachers[0].school.id') === 43
				|| _.get(this, 'user.id') === 1351942
				|| _.get(this, 'user.userType') === 'anonymous'
				|| !!this?.bulb?.teachers?.[0]?.school?.permissionKeys?.includes('enableYoutubeFriendlyUi')
      );
    },
		smallAspectRatio() {
			return this.userAgent.os.name === 'Android' && this.userAgent.browser.name === 'Chrome';
		},
		menu: {
			get() {	return this.settingsMenu },
			set(newVal) { this.setSettingsMenu(newVal) }
		},
		playerThumbnailStyle() {
			if (_.has(this.bulb,'thumbnail')) {
				return {
					'background-image': `url("${this.bulb.thumbnail}")`,
					'background-size': `${(this.bulbAttempt.resourceLinkId) ? 'contain' : 'cover'}`,
					'background-position': 'center',
    			'background-repeat': 'no-repeat',
				}
			}
			return {};
		},
		section() {
      return _.find(this.bulb.sections, { id: this.bulbAttempt.sectionId});
    },
		showReplayButton() {
			if (this.isLiveSession) return false;
			else if (this.bulbFinished && this.isBroadcastTeacher) return true;
			else if (this.bulbFinished && this.isBroadcastStudent) return false;
			return this.bulbFinished;
		},
    captionsDisabledTranscriptEnabled() {
      return (
        _.get(this.bulb, 'config.captions_disabled', 0) === 1
        || _.get(this.bulb, 'config.enable_transcript', 0) === 1
        || this.hideCaptionsEnableTranscript
      );
    },
		// isVimeoPasswordProtectedVideo() {
		// 	return (
		// 		_.get(this, 'bulb.bulbVideos[0].bulbVideoStreams[0].type', '') === 'vimeo'
		// 		&& _.get(this, 'bulb.bulbVideos[0].bulbVideoStreams[0].view', '') === 4
		// 	);
		// }
		// inspectBulbInteractionDensity() {
		// 	if (
		// 		this.interactions.length >= 10
		// 		&& !this.isLiveSession
		// 	) {
		// 		window.PP.BulbControls.dynamicallyAddedHasNewInteractionDisplayAccessFeatureFlag = true;
		// 		this.setHasNewInteractionDisplayAccess(true);
		// 	}
		// },
		bulbHasCaptions() {
			return (
				this.bulb.hasCaptions
			);	
		},
  },
  methods: {
  	...mapMutations('player', [
  		'recenterCaptions',
  		'setBulbAttempt',
			// --- BROADCAST CODE STARTS
  		'setBroadcastId',
  		'setBroadcastActiveInteractionId',
  		'setBroadcastDisplayTime',
  		'setBroadcastTeacherStatus',
  		'setBroadcastLearners',
			// -- BROADCAST CODE ENDS
  		'setDimensions',
  		'setDisplayTime',
  		'setDisplayTimeStart',
			'setHasNewInteractionDisplayAccess',
  		'setInitializingBulb',
  		'setLiveSessionUnixTime',
  		'setManualPause',
  		'setManualPlay',
  		'setMaxTime',
  		'setPreviousSessionTime',
  		'setSessionClicked',
  		'setSessionId',
  		'setSessionStartTime',
  		'setSettingsMenu',
  		'setShowInteractionsTab',
  		'setSidebarDragging',
  		'setSidebarOpen',
  		'setSidebarTab',
  		'setSidezoneOpen',
  		'setSlideInteraction',
  		'setSmallScreen',
  		'setSnackbar',
  		'setLTIsynced',
			'setPlayButtonClicked',
  		'toggleCC',
  		'setShowBroadcastStartBtn',
      'triggerBulbCompleteTab',
  	]),
  	...mapActions('player', [
  		'ltiStatusToast',
  		'sessionTime',
  		'sessionToDisplayTime',
  		'syncLtiGrade',
  		'syncLtiGradeStatus',
  	]),
		...mapMutations('interactions', [
			'updateActiveInteraction',
			'setInteractionStates',
		]),
		...mapActions('interactions', [
			'buildInteractionGroups',
			'loadPreviousInteractionAttempts',
			'requestSetActiveInteraction',
		]),
    attachBulbClasses (bulb) {
      const positPlayer = document.getElementById('posit-player');
      const customClasses = this.bulb.config.classes.split(' ');
      for (const cssClass of customClasses) {
      	positPlayer.classList.add(cssClass);
      }
    },
 		buildCompleteBulbStatement() {
			XApiService.buildCompleteBulbStatement({
        activity: {
          id: `https://xapi.playposit.com/activities/video/${this.$store.state.bulbs[0].id}`,
          name: this.$store.state.bulbs[0].title,
          lesson_id: this.$store.state.bulbs[0].id
        }
			});
			let options = {
				score:  {
					points_available: this.bulbAttempt.pointsAvailable,
	        points_earned: this.bulbAttempt.pointsEarned,
	        percent: this.bulbAttempt.pointsEarned/this.bulbAttempt.pointsAvailable,
	      }
			};
			// CaliperService.sendAssessmentEvent(options, 'submitted');
		},
		checkResumeWhereLeftOff() {
			if (
				this.isPanoptoEmbeddedIframe
				&& !this.panoptoInitialized
			) {
				return;
			}
			if (
				!this.isBroadcast
				&& !_.get(this.bulb, 'lmbId')
				&& _.get(this.bulbAttempt, 'id') !== 0
				&& _.get(this.bulbAttempt, 'maxDisplayTime') > 60
				&& !this.isLiveSession
			) {
				for (const bulbVideo of this.bulb.bulbVideos) {
					if (_.get(bulbVideo, 'bulbVideoStreams[0].type', '') === 'youtube') {
						return;
					}
				}
				this.setSnackbar({
					text: `Resume at ${new Date(_.get(this.bulbAttempt, 'maxDisplayTime') * 1000).toISOString().substr(11, 8)}?`,
		  		color: 'warning',
		  		action: 'resume',
					excludeOk: true,
		  		timeout: 10000,
				})
			}
		},
		/**
		 * Invoked in our `markBulbComplete()` method, this method handles communicating information between any potential
		 * ***frames*** within our application.
		 * 
		 * For instance, when a bulb is being played in the Playlist world -- certain bulb events are needed in order for the playlist
		 * logic to execute as expected since our player is being hosted in an iframe in the Playlist world.
		 */
		completeBulbPostMessage() {
		  try {
		    let parent = window.parent != null ? window.parent : (window.top != null ? window.top : null);
		    if (parent != null) {
		      let postObject = {
		        'type': (this.bulbAttempt.complete) ? 'playposit__completion' : 'playposit__incompletion',
		        'student_id': this.user.id,
		        'bulb_id': this.bulb.id,
		        'status': (this.bulbAttempt.complete) ? 'completed' : 'incomplete',
		        'point_available': this.bulbAttempt.pointsAvailable,
		        'point_earned': this.bulbAttempt.pointsEarned,
		        'points': 'deprecated',
	        }
					// ! Should really lock down our target origin, not allow any and all origins to recieve this message.
	        parent.postMessage(JSON.stringify(postObject), '*');
		    }
		  } catch (e) {
		    // -- catch the error here and log it to GA
		    dataLayer.errorLog({msg: `Unable to send post message. parent ${parent} err: ${JSON.stringify(e)} sessionId: ${this.sessionId}`, location: 'BulbControls: completeBulbPostMessage'})
		  }
		},
		/**
		 * Also invoked in our `markBulbComplete()` method, however this method handles communicating information between ***browsing contexts***
		 * within our application -- that is: windows, *tabs*, frames, or iframes and workers on the *same origin*.
		 */
		broadcastBulbCompletion() {
			this.bulbControlsBroadcastChannel.postMessage(PlayPositBroadcastChannelEventNames.PEER_REVIEW_STUDENT_FEEDBACK_GIVEN);
		},
		fullscreenToast() {
			if (
				(
					!this.mobile
					&& this.screenWidth < 480
					&& this.screenRatio > .7
				)
				|| (
					!this.mobile
					&& this.screenWidth < 1000
					&& _.get(this, 'bulb.teachers[0].school.config.permissions', []).includes('barbriStyle')
					)
				)
				{
					this.setSmallScreen(true);
					this.setSnackbar({
						text: _.get(this, 'bulb.teachers[0].school.config.permissions', []).includes('barbriStyle') ? 'For best results, complete activities in full-screen mode.'
						: 'For better experience launch fullscreen mode.',
			  		color: 'warning',
			  		action: 'fullscreen',
			  		timeout: 0,
					})
			} else {
				this.setSmallScreen(false);
			}
		},
		handleEnterSession() {
			this.playButtonClick();
			this.initializePlay();
			this.requestPause();
			if (this.startTimeDifference <= 0) {
				setTimeout(() => {
					this.startSessionTimeLoop();
					this.setSessionClicked(true);
				}, 3000);
			} else {
				this.timeUntilStartAriaLabel = `${this.startTimeDifference > 60 ? this.timeRemainingUntilStart : 'Class will start in ' + this.startTimeDifference} seconds.`;
				this.hideAriaLabel();
				this.setSessionClicked(true);
			}
		},
		hideAriaLabel() {
			setTimeout(() => {
				this.hideLabel = true;
			}, 3000);
		},
		initializeMaxTime() {
  		/**
  		 * Set the initialMax time. If fast forwarding is allowed set it to the required max time
  		 * otherwise use the bulbAttempts maxDisplayTime property
  		 */
  		if (this.bulb.config.fast_yes) this.setMaxTime(this.requiredMaxTime)
  		else if (this.bulbAttempt.maxDisplayTime) this.setMaxTime(this.bulbAttempt.maxDisplayTime)
  	},
  	initializePlay() {
  		/**
  		 * browsers at least one user click action before videos will play
  		 * this method tracks that user click has been preformed
  		 */
			this.playButtonClick();
			if (!this.initializing && !this.bulbInitialized) this.setInitializingBulb(true);
			// -- if not a broadcast session or if not a student broadcast session
			this.setManualPlay(true);
			if (this.$store.state.mobile) { // undefined... how long has it been this way?
				EventBus.$emit('requestAction', { key: 'play', forceToAll: true, setDesiredState: true });
			} else {
				EventBus.$emit('requestAction', { key: 'play', setDesiredState: true });
			}
			this.checkResumeWhereLeftOff();
  	},
  	liveSessionTimeSinceUpdate() {
  		const bulbControlsComponent = this;
	  	this.liveSessionInterval = setInterval(() => {
	  		bulbControlsComponent.liveSessionTimeUpdateDifference += 1;
  		}, 1000);
  	},
  	async markBulbComplete() {
			if (
				this.isBroadcast
				&& this.user.userType === 'teacher'
			) {
				// -- trigger on question open
				triggerInstructorStatus(this.broadcastId, 'complete');
			}
  		if (
				this.bulbAttempt
				&& this.user.userType === 'student'
			) {
    		// triggered during last 10 seconds, no incomplete questions, display_time past the last question
  			// this.buildCompleteBulbStatement(lesson);
				let isBulbCompleted = 1;
				if (
					!this.isLiveSession
					&& !this.isBroadcast
					&& this.bulb.config?.scoreThreshold
				) {
					isBulbCompleted = this.passedScoreThreshold();
				}
				const updateData = {
			    complete: isBulbCompleted,
			    completionTime: (isBulbCompleted) ? moment() : null,
			    maxDisplayTime: this.displayTime,
					...(this.bulb.config?.scoreThreshold && { scoreThreshold : this.bulb.config.scoreThreshold }),
					lti13Launch: !!this.lti13Launch,
					...(!!this.lti13Launch && { issuer: this.lmsIssuer }),
  			}
  			updateData.timeElapsed = await this.sessionTime();
  			
  			if (
					this.user.isLti
					&& this.user.enableGrading === 1
					&& this.user.gradePassbackUrl
				) {
					// bulbAttempt Update with LTI grade Sync
					try {
						const res = await PlayerService.updateSyncBulbAttempt(this.bulbAttempt.id, updateData);

						// update vuex with complete bulbAttempt data
    				this.setBulbAttempt(res.data.bulbAttempt);
						if (
							this.bulbAttempt.complete
							&& res.data.syncStatus
						) {
							//update sync boolean and do toast
							this.ltiStatusToast(res.data.syncStatus.msg);
							setTimeout(() => { this.syncLtiGradeStatus(); }, 1500);
						}
						this.openBulbCompleteTab();
					} catch(err) {
						if (
							err.bulbAttempt
							&& !err.updateErr
							&& err.ltiErr
						) {	// validates that it was only a sync error
	    				// update vuex with complete bulbAttempt data
  						this.setBulbAttempt(ba.data.bulb_attempt);
  						this.openBulbCompleteTab();
  						this.setSnackbar({
	              text: `Grade Sync Error: ${err.ltiErr}`,
	              color: 'warning'
	            });
  					} else {
  						// something went wrong with the bulbAttempt update
	    				this.setSnackbar({
	              text: `Failed to mark ${this.termForBulb} complete.`,
	              color: 'warning'
	            });
  					}
					}
  			} else if (
	  				this.studentSubmissionId
	  				&& this.isSchoolUser
					) { // update bulbAttempt and sync grades with Google Classroom
	  			try {
	  				const { data: response } = await PlayerService.updateBulbAttemptSyncGoogle({
	  					bulbAttemptId: this.bulbAttempt.id,
	  					courseId: _.get(this.section, 'key', '').substring(1),
	  					courseWorkId: _.get(this.section, 'bulbSection.courseWorkId'),
	  					updateData,
	  					studentSubmissionId: this.studentSubmissionId,
	  				});
	  				this.setBulbAttempt(response.bulbAttempt);
	  				this.openBulbCompleteTab();
	  				if (!response.synced) {
	  					this.setSnackbar({
		            text: `Grades Sync Error`,
		            color: 'warning'
		          });
	  				} else {
	  					this.setSnackbar({
		            text: `Grades Synced to Google Classroom`,
		            color: 'success'
		          });
	  				}
	  			} catch(e) {
	  				this.setSnackbar({
              text: `Failed to mark ${this.termForBulb} complete.`,
              color: 'warning'
            });
	  			}
  			} else {
					// bulbAttempt Update
					try {
						const ba = await PlayerService.updateBulbAttempt(this.bulbAttempt.id, updateData);
						this.setBulbAttempt(ba.data.bulb_attempt);
						this.openBulbCompleteTab();
					} catch (err) {
						this.setSnackbar({
              text: `Failed to mark ${this.termForBulb} complete. ${err.updateErr}`,
              color: 'warning',
            });
					}
  			}
				if (this.isPeerReview) this.broadcastBulbCompletion();
  			this.completeBulbPostMessage();
				const { data: bulbAttempt } = await PlayerService.sendProquestBulbAttemptUpdate({
					bulbAttemptId: this.bulbAttempt.id,
					event: 'complete',
				});
				if (
					bulbAttempt?.id
					&& window.self !== window.top
				) {
					window.parent.postMessage(JSON.stringify({
						type: 'bulbAttempt',
						event: 'complete',
						data: _.omit(bulbAttempt, ['bulb']),
					}), '*');
				}
 			} else {
				this.bulbAttempt.complete = true;
  			this.openBulbCompleteTab();
			}
  	},
  	processingData(meta) {
  		// helper method to determine if an interaction is doing any data processing
  		return meta.isRecordingAudio && meta.isProcessingData && meta.isProcessingSecondaryData
  	},
		requestPlay() {
			this.setManualPlay(true);
			if(this.isBroadcast) this.setShowBroadcastStartBtn(false);
			EventBus.$emit('requestAction', { key: 'play', setDesiredState: true });
		},
		requestPause() {
			this.setManualPause(true);
			EventBus.$emit('requestAction', {key: 'pause', setDesiredState: true });
		},
		seek(displayTime) {
			EventBus.$emit(
				'requestAction', {
					key: 'seek',
					seekTime: displayTime,
			});
		},
		sendBulbEndedPostMessage() {
		  try {
		    let parent = window.parent != null ? window.parent : (window.top != null ? window.top : null);
		    if (parent != null && this.bulbAttempt && this.user.userType === 'student') {
		      let postObject = {
		        'type': 'playposit__video_end',
		        'student_id': this.user.id,
		        'bulb_id': this.bulb.id,
		        'status': 'completed',
		        'point_available': this.bulbAttempt.pointsAvailable,
		        'point_earned': this.bulbAttempt.pointsEarned,
	        }
	        parent.postMessage(JSON.stringify(postObject), '*');
		    }
		  } catch (e) {
		    // -- catch the error here and log it to GA
		    dataLayer.errorLog({msg: `Unable to send post message. parent ${parent} err: ${JSON.stringify(e)} sessionId: ${this.sessionId}`, location: 'BulbControls: sendBulbEndedPostMessage'})
		  }
		},
    buildActiveGroup() {
    	const activeGroup = [];
    	let newSidebar = false;
    	let newOverlay = false;
    	let cycleInteraction = false;
    	let next = null;

			// loop all interactions
			this.interactionStates.forEach((state, i) => {
				// check if interaction is in the displayRange
				if (
					this.inDisplayRange(
						state.interaction,
						this.displayTime,
						Math.min(activeGroup.length, 30) * this.groupFuzz
					)
					&& !state.interactionMeta.rubric
				) {
					// add to activeGroup
					activeGroup.push(this.interactionStates[i]);
					if (!state.interactionMeta.inDisplayRange) {
						// interaction was just added to the group
						// it's a pausing interaction, trigger pause
						if (state.interaction.pause) EventBus.$emit('requestAction', 'pause');
						// sidebar is closed or viewing notes, open up the interactions tab and set this interaction as the new active one
						if (
							!state.interactionMeta.overlay
							&& !state.interactionMeta.hiddenByRequired
							&& (
								!this.showInteractionsTab
								|| !this.sidebarOpen
							)
							&& !next
						) {
							next = state.interaction;
						}
						// helper vars for triggering correct AssistiveStatus
						if (state.interactionMeta.overlay) newOverlay = true;
						else newSidebar = true;
					}
					// set interaction meta in displayRange
					if (
						this.isBroadcast
						&& this.isBroadcastStudent
					) {
						if(this.broadcastActiveInteractionId){
							this.$set(this.interactionMetas[i], 'inDisplayRange', true);
						} else {
							this.$set(this.interactionMetas[i], 'inDisplayRange', false);
						}
					} else {
						this.$set(this.interactionMetas[i], 'inDisplayRange', true);
					}
				}
				else {
					if (
						state.interactionMeta.inDisplayRange
						&& this.activeInteraction
						&& this.activeInteraction.id === state.interaction.id
					) {
						// activeInteraction is no longer in the displayRange, grab the next one to
						cycleInteraction = true;
					}
					// set interaction meta no longer in displayRange
					this.$set(this.interactionMetas[i], 'inDisplayRange', false);
				}
			});

			this.setOverlayFocus(newOverlay, newSidebar);
			// [ ] break into a separate function: handleNewActiveGroup()
			if (!activeGroup.length) {
				// no more active interactions, set active to null
				this.requestSetActiveInteraction(null);
			} else if (cycleInteraction || next) {
				// there are still interactions at the current timestamp, we need select them
				// console.log('cycleInteraction', next, _.filter(activeGroup, agi => !agi.interactionMeta.overlay))
				// we were provided the next interaction to use
				if (next) {
					if(this.isBroadcast && this.isBroadcastStudent){
						this.requestSetActiveInteraction(null);
					} else {
						this.requestSetActiveInteraction(next); // set the next sidebarInteraction
					}
				}
				else {
					// determine the next interaction
					const sidebarActiveGroup = _.filter(activeGroup, agi => !agi.interactionMeta.overlay && !agi.interactionMeta.hiddenByRequired);
					if (sidebarActiveGroup.length) this.requestSetActiveInteraction(sidebarActiveGroup[0].interaction) // set first in activeGroup
					else {
						 // only hotspots left in the active group, turn off the current sidebar activeInteraction
	 					this.requestSetActiveInteraction(null);
					}
				}
			}
			else if (!this.activeInteraction) this.requestSetActiveInteraction('next')
			// console.log('inDisplayRange', this.displayTime, _.map(this.interactionMetas, x => x.inDisplayRange).slice(1,6))
			//not beautiful but safety measure in our assumption that Qs are always 10ms apart and in case they manually set the times of dozens of questions with nanosecond
    },
    inDisplayRange(interaction, time, groupFuzz) {
  		// if the interaction is inside the time and should be shown so we don’t miss it.
    	// groupfuzz is incremented each time to nudge time ahead to look for concurrent interactions
    		// console.log((interaction.displayInTime - (this.lookaround * 9) - groupFuzz).toFixed(3),'<',time.toFixed(3) ,'<=', Math.max(interaction.displayOutTime + this.lookaround, .5).toFixed(3));
    		// console.log('\t',time > (interaction.displayInTime - (this.lookaround * 3) - groupFuzz)) && (time <= Math.max(interaction.displayOutTime + this.lookaround, .5))
    		if (time < .5) {
    			return (time > (interaction.displayInTime - (this.lookaround * 3) - groupFuzz)) && (time <= Math.max(interaction.displayOutTime + this.lookaround, .5))
    		}
    		return (time > (interaction.displayInTime - (this.lookaround * 3) - groupFuzz)) && (time <= interaction.displayOutTime + this.lookaround);
				// 2.96 + .3 (fwd)
				// 2.96 - .1 (bck) < 3.07 .
				// dt - lookupBackwards
				// start the interaction: (time > (displayInTime - (this.lookaround * 3) - groupFuzz))
				//  2.96 > 3.07 - .1 - (.01 * 2)
    },
    openBulbCompleteTab() {
  		if (this.hasRubric) {
        let message = '';
        if (
					(this.displayDuration - this.rubricSubmitted <= 2)
					|| this.rubricSubmitted
				) {
          this.openTab('bulb-info-tab');
          message = this.displayDuration - this.rubricSubmitted <= 2 ? `Rubric Submitted and ${this.termForBulb.capitalize()} Complete.` : `${this.termForBulb.capitalize()} Complete`;
          this.triggerBulbCompleteTab();
        } else {
          this.openTab('rubric-tab');
          message = `${this.termForBulb.capitalize()} Complete`;
          this.triggerBulbCompleteTab();
        }
  			this.$nextTick(() => {
  				this.setSnackbar({
		        text: message,
		        color: 'success',
		      });
  			})
			} else if(!this.bulbAttempt.complete) {
				this.openTab('bulb-info-tab');
				this.setSnackbar({
					text: `You did not score the minimum requirement of ${this.bulb.config?.scoreThreshold}%. Please try again.`,
					color: 'info',
					timeout: 5000,
				});
			}
			else {
    		this.openTab('bulb-info-tab');
	    	this.setSnackbar({
	        text: _.get(this, 'bulb.teachers[0].school.config.permissions', []).includes('barbriStyle') ? 'Video Complete.' : `${this.termForBulb.capitalize()} Complete.`,
	        color: 'success'
	      });
    	}
  	},
    openInteractionTab() {
    	if (!this.sidebarOpen) this.setSidebarOpen(true);
      if (!this.showInteractionsTab) this.setShowInteractionsTab(true);
    },
    openTab(tab) {
    	this.setSidebarTab(tab);
			this.setShowInteractionsTab(false);
			this.setSidebarOpen(true);
    },
		setupControlsWrapper() {
			const [
				videoContainer,
				controlsWrapper,
				uiSlidernoUiConnect,
			] = [
				this.$refs.videoContainer,
				this.$refs.controlsWrapper,
				document.getElementsByClassName('noUi-connect')[1],
			];
			if (this.sidebarStyle === 'portrait') {
				controlsWrapper.style.top = videoContainer.offsetHeight + 'px';
				uiSlidernoUiConnect.style.background = '#424242';
			} else {
				controlsWrapper.style.top = null;
				uiSlidernoUiConnect.style.background = 'white';
			}
			setTimeout( () => { this.setupSettingsDialog(); }, 100);
		},
		setupSettingsDialog() {
			const [
				videoContainer,
				controlsWrapper,
				settingsMenuDialogContent,
			] = [
				this.$refs.videoContainer,
				this.$refs.controlsWrapper,
				this.$refs.settingsMenuDialogTooltip.children[0],
			];
			// The 119 is the offsetHeight of the settings dialog content card.
			if (this.sidebarStyle === 'portrait') settingsMenuDialogContent.style.height = `${videoContainer.offsetHeight + controlsWrapper.offsetHeight + 119}px`;
			else settingsMenuDialogContent.style.height = null;
		},
    startSessionTimeLoop() {
    	if (!this.sessionTimeLoopStarted) {
    		this.sessionTimeLoopStarted = true;
    		this.seek(0);
    		this.sessionFrameId = requestAnimationFrame(this.sessionTimeUpdateLoop);
    		this.liveSessionTimeSinceUpdate();
    	}
    },
    stopSessionTimeLoop() {
  		this.sessionTimeLoopStarted = false;
  		cancelAnimationFrame(this.sessionFrameId);
  		clearInterval(this.liveSessionInterval);
    },
    sessionTimeUpdateLoop() {
  		this.throttleUpdateLiveSessionUnixTime();
  		if (this.sessionTimeLoopStarted) {
      	this.sessionFrameId = requestAnimationFrame(this.sessionTimeUpdateLoop);
  		}
    },
    throttleUpdateLiveSessionUnixTime: _.throttle(function () {
    	this.liveSessionTimeUpdateDifference = 0;
      this.setLiveSessionUnixTime((_.max([(parseInt((new Date().getTime() / 10), 10) / 100  - this.liveSessionStartTime).toFixed(2), 0])));
      this.sessionToDisplayTime();
    }, 1000),
    calculateTimeUntilSessionStarts() {
			if (!this.isLiveSession) return;
			else if (this.startTimeDifference > 0) {
				setTimeout(() => {
					this.startTimeDifference = Math.trunc((this.liveSessionStartTime - parseInt((new Date().getTime() / 1000).toFixed(0), 10)));
					if (this.startTimeDifference > 600) this.timeRemainingUntilStart = `Class will start ${moment.duration(this.startTimeDifference * 1000).humanize(true)}`
					else if (this.startTimeDifference <= 600 && this.startTimeDifference > 540) this.timeRemainingUntilStart = 'Class will start in 10 minutes'
					else if (this.startTimeDifference <= 540 && this.startTimeDifference > 480) this.timeRemainingUntilStart = 'Class will start in 9 minutes'
					else if (this.startTimeDifference <= 480 && this.startTimeDifference > 420) this.timeRemainingUntilStart = 'Class will start in 8 minutes'
					else if (this.startTimeDifference <= 420 && this.startTimeDifference > 360) this.timeRemainingUntilStart = 'Class will start in 7 minutes'
					else if (this.startTimeDifference <= 360 && this.startTimeDifference > 300) this.timeRemainingUntilStart = 'Class will start in 6 minutes'
					else if (this.startTimeDifference <= 300 && this.startTimeDifference > 240) this.timeRemainingUntilStart = 'Class will start in 5 minutes'
					else if (this.startTimeDifference <= 240 && this.startTimeDifference > 180) this.timeRemainingUntilStart = 'Class will start in 4 minutes'
					else if (this.startTimeDifference <= 180 && this.startTimeDifference > 120) this.timeRemainingUntilStart = 'Class will start in 3 minutes'
					else if (this.startTimeDifference <= 120 && this.startTimeDifference > 60) this.timeRemainingUntilStart = 'Class will start in 2 minutes'
					this.calculateTimeUntilSessionStarts();
				}, 1000)
			} else if (this.startTimeDifference <= 0 && this.sessionClicked) {
	  			this.startSessionTimeLoop();
	  			this.requestPlay();
			}
		},
    toggleFullScreen() {
			if (this.screenfull?.isEnabled) {
				this.screenfull.toggle();
			} else if (!this.screenfull?.isFullscreen) {
				console.log('Fullscreen functionality is not enabled.');
				this.screenfull.request().catch((e) => console.log('PlayPosit error - failed to enable fullscreen', e));
			}
    },
		togglePlayPause() {
			if (this.playerState === 'play') {
				this.requestPause();
			}
			else this.requestPlay();
		},
		replayVideo() {
			// Only way to replay a video is if the user has finished watching the bulb:
			if (this.bulbFinished) {
				this.seek(0);
				this.requestPlay();
				this.setSidebarOpen(false);
			}
		},
    toggleSidezone() {
  		this.setSidezoneOpen(!this.sidezoneOpen);
  		this.setSidebarOpen(this.sidezoneOpen)
  		this.$nextTick(() => {
  			this.setFirstFocus(document.getElementById('sidebarTabs'));
			});
  	},
  	toggleSettings() {
  		if (this.menu) {
  			this.menu = false;
				// set focus back on toggle
				this.$refs.settingsToggle.$el.focus();
  		} else {
  			this.menu = true;
  			setTimeout(() => {
	  			this.setFirstFocus(this.$refs.settings.$el);
  			}, 200)
  		}
  	},
  	setOverlayFocus(newOverlay, newSidebar) {
  		// if there is a new overlay in the activeGroup and there are no new sidebar interactions we need to focus on the overlay container
			if (newOverlay && !newSidebar) {
				// interaction.vue handles setting focus for newActiveInteractions. Here we have a new overlay so we trigger the AssistiveStatus here
				this.$nextTick(() => {
  				document.querySelector('#overlay-assist').focus();
				})
			}
  	},
  	updateTimeElapsed: async function() {
			try {
				// Will fire a timeupdate every 90-120 seconds
				const roundedMaxTime = Math.floor(this.bulbAttempt.maxDisplayTime / this.randomTimeUpdateVar);
				// update bulbAttempt data if 10 player seconds have passed since the last update
				const bulbViewIncrement = Math.floor(this.displayTime / 10) * 10 >= 10 && !this.updatedViewCount && !this.user.readOnly;
				if (roundedMaxTime > this.roundTime && this.bulbAttempt.id && !this.bulbAttempt.complete && this.user.userType === 'student') {
					this.roundTime = roundedMaxTime;
					const currentTimeElapsed = await this.sessionTime();
					const updateData = {
						maxDisplayTime: this.bulbAttempt.maxDisplayTime,
						timeElapsed: _.get(this.bulb, 'config.fast_yes', false) ? currentTimeElapsed : _.max([this.bulbAttempt.maxDisplayTime, currentTimeElapsed]),
					}
					// updateBulbAttempt to the amount of time a user has been on a bulb
					await PlayerService.updateBulbAttemptTime(this.bulbAttempt.id, updateData, {timeout: 5000});
					// update vuex.bulbAttempt with the new times if update was successful
					this.setBulbAttempt(updateData);
				}
				if (bulbViewIncrement) {
					this.updatedViewCount = true;
					PlayerService.updateBulbViewCount(this.bulb.id).catch(err => { this.updatedViewCount = false; });
				}	
			} catch (error) {
				const msg = `${error.toString()} displayTime: ${this.displayTime} sessionId: ${this.sessionId} ${updateData ? `updateData ${JSON.stringify(updateData)}` : ''}`;
				dataLayer.errorLog({
					msg,
					location: 'BulbControls: updateTimeElapsed',
					sessionId: this.sessionId,
				});
			}
    },
		windowResize() {
			/**
			 * update the screen dimension vars from window properties
			 * [ ] see if this can be refactored with vuex
			 */
			 	this.resizeThrottle = true
				this.setDimensions({
					width: window.innerWidth,
					height: window.innerHeight,
				});
				// Duct tape for iOS mobile and Safari auto hiding their bottom chrome
				if (
					this.mobile
					&& this.userAgent.os.name === 'iOS'
					&& !navigator.userAgent.match('CriOS')
				) {
		 			document.body.style.height = `${window.innerHeight}px`;
			 	}
				if (
					!this.sidezoneOpen
					&& window.innerWidth <= 425
				) {
					this.setSidezoneOpen(true);
				}
				this.$nextTick(() => {
					this.recenterCaptions();
					this.setupControlsWrapper();
				});
		},
		broadcastEventListeners(name, type, data) {
			if(this.isBroadcast && this.user.userType === 'teacher') {
				if(name === 'history') {
					this.setBroadcastLearners({
						learnerId: data.learnerId,
						data: data.data,
					});
				}
			}
			else if(this.isBroadcast && this.user.userType === 'student') {
				if(name === 'broadcast') {
					this.$store.commit('player/setBroadcastTeacherStatus', data.status);
					this.$store.commit('player/setBroadcastDisplayTime', data.displayTime);
					this.$nextTick(() => {
						this.$store.commit('player/setBroadcastActiveInteractionId', data.interaction_id);
					});

					if(data && data.status === 'complete') {
						this.markBulbComplete();
					}
				}
			}
		},
		fetchQuestionFromBroadcast() {
			const self = this;
      getCurrentInteractionFromFirestore(this.broadcastId).then(data => {
				console.log('data:: ', data);
				self.$store.commit('player/setBroadcastTeacherStatus', data.status);
        self.$store.commit('player/setBroadcastDisplayTime', data.displayTime);
				self.$nextTick(() => { self.$store.commit('player/setBroadcastActiveInteractionId', data.interaction_id); });
      })
      .catch(err => {
        self.setSnackbar({
          text: `No question on instructor side.`,
          color: 'warning'
        });
      });
		},
		async handleExpiredCheckout({
			title,
			code = _.isNil(this.sessionId) ? 400 : this.sessionId,
			text
		} = {}) {
			try {
				const data = await PlayerService.unlockBulbCheckout(this.bulb.id);
			} finally {
				this.$enablePlaypositErrorScreen({
					active_color: this.$vuetify.theme.primary,
					base_color: this.$vuetify.theme.secondary,
					inactive_color: this.$vuetify.theme.tertiary,
					title,
					code,
					text,
				});
				setTimeout(() => {
					const applicationElement = document.getElementById('app');
					if (applicationElement) applicationElement.remove();
				}, 1000);
			}
		},
		resetInactivityTimer() {
			if (!this.isBulbCheckoutEnabled) return;
			clearTimeout(this.inactivityTimer);
			this.inactivityTimer = setTimeout(this.handleExpiredCheckout, 300000, {
				title: 'Removed for Inactivity',
				text: `You have been removed from your ${this.termForBulb} attempt because you were inactive for 30 minutes.`,
			}); // 30 minutes (1800000)
		},
		initCheckoutTimer() {
			if (!this.isBulbCheckoutEnabled) return clearTimeout(this.checkoutTimer);
			const {
				time,
				duration,
			} = this.bulb.config.checkout;
			if (moment(time).add(duration, 'minutes').isBefore(moment())) {
				clearTimeout(this.checkoutTimer);
				return this.handleExpiredCheckout({
					title: 'Checkout Expired',
					text: 'This video has copyright viewing restrictions. Your checkout time has expired.',
				});
			}
			return this.checkoutTimer = setTimeout(this.initCheckoutTimer, 1000);
		},
		passedScoreThreshold() {
			// bulb has been completed if the score-threshold has been achieved:
			const score = Math.round((this.bulbAttempt.pointsEarned / this.bulbAttempt.pointsAvailable) * 100);
			return (score >= this.bulb.config.scoreThreshold) ? 1 : 0;
		},
		initializeBulbControlsBroadcastChannel() {
			this.bulbControlsBroadcastChannel = new BroadcastChannel(PlayPositBroadcastChannels.bulbControlsBroadcastChannel);
			// ? As of yet -- we currently don't have any necessary channel events needed for this Vue component, however
			// ? we might in the future.
			// this.listenForBroadcastChannelEvents();
		},
		redirectUserToPanoptoKbHelpArticle() {
			window.open('https://knowledge.playposit.com/article/299-panopto-video', '_blank');
		},
		playButtonClick() {
			this.setPlayButtonClicked(true);
		},
		handleVideoContainerRequestActionClassState(requestActionKey) {
			if (!this.$refs.videoContainer) return;
			const playbackEvent = _.isObject(requestActionKey) ? requestActionKey?.key : requestActionKey;
			if (['play', 'pause'].includes(playbackEvent)) {
				if (this.$refs.videoContainer.classList.contains('play') && playbackEvent === 'pause') 	this.$refs.videoContainer.classList.remove('play');
				if (this.$refs.videoContainer.classList.contains('pause') && playbackEvent === 'play') 	this.$refs.videoContainer.classList.remove('pause');
				this.$refs.videoContainer.classList.add(playbackEvent);
			}
		},
		handlePlayerContainerMousemoveEvent: _.throttle( function(event) {
			if (this.playerControlsDisplayType.toLowerCase() !== 'fade') return;
			clearTimeout(this.positWrapperMousemoveTimeout);
			this.$refs.controlsWrapper.style.setProperty('opacity', 1);
			this.positWrapperMousemoveTimeout = setTimeout(() => {
				this.playerControlsDisplayType.toLowerCase() !== 'fade' ?
					this.$refs.controlsWrapper.style.setProperty('opacity', 1) :
					this.$refs.controlsWrapper.style.setProperty('opacity', 0);
			}, 3500);
		}, 500),
		handleWindowUnloadEvent() {
			const [
				beaconBulbId,
				beaconToken,
			] = [
				this.bulbAttempt.id,
				this.user.token
			];

			window.addEventListener('beforeunload', async (event) => {
				this.requestPause();
				// -- Reset broadcast triggers
				if (this.isBroadcast) {
					if (
						this.user
						&& this.user.userType === 'teacher'
					) {
						triggerInstructorStatus(this.broadcastId, 'offline');
					} else if (
						this.user
						&& this.user.userType === 'student'
					) {
						triggerLearnerStatus(this.broadcastId, this.user.id, this.bulbAttempt.id, 'offline');
					}
					event.returnValue = null;
				}

				if (
					this.hasRubric
					&& !this.rubricSubmitted
					&& this.user
					&& this.user.userType === 'student'
				) {
					// Warn users that the rubric is not saved
					event.returnValue = 'Your rubric is not submitted and data will be lost.'
				}

				let passedScoreThreshold = true;
				if (this.bulb.config?.scoreThreshold) passedScoreThreshold = this.passedScoreThreshold();
				if (
					this.bulbInitialized
					&& this.bulbAttempt.id
					&& !this.bulbAttempt.complete
					&& passedScoreThreshold
					&& !this.tokenRefresh
				) {
					const [
						beaconTimeElapsed,
						beaconMaxDisplayTime
					] = [
						await this.sessionTime(),
						this.bulbAttempt.maxDisplayTime,
					];
					PlayerService.sendBeacon(beaconBulbId, beaconToken, beaconTimeElapsed, beaconMaxDisplayTime);
				}
			});
		},
		// handleVimeoPasswordProtectedVideoPreloader() {
		// 	const container = document.getElementById('password-protected-vimeo-video');
		// 	const vimeoPasswordProtectedAnimation = this.createLottieAnimation({
		// 		container,
		// 		renderer: 'svg',
		// 		animationData: vimeoPasswordAnimation,
		// 		name: 'Vimeo password protected bulb',
		// 		rendererSettings: {
		// 			className: 'vimeo-password-protected-custom-player-preloader',
		// 		},
		// 	});
		// 	container.addEventListener('mouseover', () => {
		// 		vimeoPasswordProtectedAnimation.goToAndStop(177, true);
		// 	});
		// 	container.addEventListener('mouseleave', () => {
		// 		vimeoPasswordProtectedAnimation.play();
		// 	});
		// 	return;
		// },
  },
	watch: {
    'bulbFinished'() {
    	if (this.bulbFinished && !this.bulbAttempt.complete) this.markBulbComplete();
    	else if (this.bulbFinished && this.bulbAttempt.complete) {
    		this.openTab('bulb-info-tab');
    		this.sendBulbEndedPostMessage();
    	}
    	if (this.sessionTimeLoopStarted && this.bulbFinished) {
    		this.stopSessionTimeLoop();
    		this.openTab('bulb-info-tab');
    	}
    },
    'bulbCompleteTab'(n, o) {
			if (n) {
				this.openBulbCompleteTab();
				this.triggerBulbCompleteTab();
			}
		},
		'displayTime'(newPlayerTime) {
			this.resetInactivityTimer();
			// could we consolodate this logic somewhere that already has a display_time
			this.$nextTick(() => {
				this.buildActiveGroup();
				if (this.hasNewInteractionDisplayAccess) {
					// update the states for all the interactions
					this.setInteractionStates();
				}
			});
			if(!this.scrubbing) {
				// Update slider position as video plays, ignoring skipping;
				if (Math.abs(newPlayerTime - this.slider.get()[1]) > 1) {
					// display time was updated but the scrubber isn't getting dragged
					// update set the new slider position to match the display_time
					this.slider.set([0, Math.round(this.displayTime), Math.min(this.maxTime, this.requiredMaxTime)]);
				}
			}
			// Update max time
			if (this.displayTime > this.maxTime){
				this.setMaxTime(this.bulb.config.fast_yes ? this.requiredMaxTime : this.displayTime);
			}
			if (this.displayTime > this.bulbAttempt.maxDisplayTime) {
				this.bulbAttempt.maxDisplayTime = this.displayTime;
			}
			if ((this.displayTime >= this.displayDuration - .2) && !this.reachedMaxTime) {
				this.reachedMaxTime = true;
			}

			if (((this.displayTime >= this.requiredMaxTime - (this.lookaround * 3)) || (this.displayTime >= this.displayDuration)) && this.hasRequiredInteractions) {
				// we just hit the required max time and there are still required interactions, pause the video
				// VideoInstance prevents displayTime from ever being greater than required_max_time
				// [ ] we should discuss required interactions and how they affect playback
				EventBus.$emit('requestAction', 'pause');
				// [ ] REFACTOR to not go by index and to use a smaller array
				const reqIndex =  _.findIndex(this.interactionStates, is => !is.interactionMeta.overlay && is.interaction.isRequired && !is.interactionMeta.isInteractionAnswered && (is.interactionMeta.inDisplayRange || is.interactionMeta.rubric))
				if (reqIndex >= 0 && !this.interactionStates[reqIndex].interactionMeta.overlay && !this.interactionStates[reqIndex].interactionMeta.hiddenByRequired) {
					if (!this.interactionStates[reqIndex].interactionMeta.rubric && !this.isLiveSession || (this.isLiveSession && !this.interactionStates[reqIndex].interactionMeta.viewed)) {
						/*
							For liveSessions we use the interactionMeta.viewed variable to track when the interaction has been displayed
							to the user. This helps us track when durational interactions have been displayed and closed by the user.
							If the interaction has been viewed and closed we don't try to force the interaction to be active until we
							reach the displayOutTime of the interaction.
						*/
						this.setSnackbar({text: `Complete required interaction ${this.hasRubric && !this.rubricSubmitted ? 'and rubric ' : ''}before continuing.`});
						this.requestSetActiveInteraction(this.interactions[reqIndex]);
						this.openInteractionTab();
					} else if (this.interactionStates[reqIndex].interactionMeta.rubric) {
						this.setSnackbar({text: `Complete rubric to finish the ${this.termForBulb}.`});
						this.openTab('rubric-tab');
					}
				}
			}
			// update timeElapsed if 30 seconds have passed since the last update
			this.updateTimeElapsed();
		},
		'displayDuration'() {
		  if (this.slider) {
				this.slider.updateOptions({
				  range: {
						min: 0,
						max: this.displayDuration || 1,
				  },
				});
		  }
		  if (this.bulb.config.fast_yes) { // allows users to fast forward
		  	// still can't progress past required questions
		  	this.setMaxTime(this.requiredMaxTime);
		  }
    },
    'liveSessionTimeUpdateDifference' (n, o) {
    	if (
    		this.isLiveSession
    		&& n
    		&& n > 1
  		) {
  			console.log('Longer than 1 sec since last update - Trigger manual update!')
				this.throttleUpdateLiveSessionUnixTime();
			}
    },
		'liveSessionStartTime' (n, o) {
			if (this.isLiveSession && n) {
				this.startTimeDifference = Math.trunc((this.liveSessionStartTime - parseInt((new Date().getTime() / 1000).toFixed(0), 10)));
				this.calculateTimeUntilSessionStarts();
			}
		},
		'requiredMaxTime'() {
			if (this.bulb.config.fast_yes) {
				// update max_time to the next required question
				this.setMaxTime(this.requiredMaxTime);
			}
			this.slider.set([0,this.displayTime, Math.min(this.maxTime, this.requiredMaxTime)])
    },
		'rubricSubmitted'() {
			if (this.reachedMaxTime && !this.hasRequiredInteractions) this.markBulbComplete();
		},
		'screenRatio'() {
			this.fullscreenToast();
		},
		'sessionClicked'(n, o) {
			if (!n && o) {
				this.stopSessionTimeLoop();
			}
		},
		'bulbInitialized'(n, o) {
      if (this.bulbInitialized) {
				this.setupControlsWrapper();
      	this.setInitializingBulb(false);
      	if (this.user.userType === 'student') this.loadPreviousInteractionAttempts(this.bulbAttempt.id);
        if (this.displayTimeStart) {
      		this.setDisplayTime(this.displayTimeStart);
					EventBus.$emit('requestAction', {key: 'seek', seekTime: this.displayTimeStart});
        	this.setDisplayTimeStart(null);
        }
			  if (isNaN(this.displayDuration)) {
					const buttons = [];
					if (!this.user.isLti && !this.isPlaylist) {
						const token = this.user.token ? `?token=${this.user.token}` : '';
						buttons.push({
							text: 'Back to Dashboard',
							action: () => {
								window.location = `/dash/${token}`;
							}
						});
					}
		  		this.setSnackbar({
			  		text:`Error loading ${this.termForBulb}.`,
			  		color: 'error',
			  		action: 'more-info',
			  		bluescreen: {
			  			title: `Error Loading ${this.termForBulb.capitalize()}`,
			  			subtitle: `There was an issue calculating ${this.termForBulb} duration`,
			  			text: 'This can occur due to invalid cropping or failed video streams. Please check with your instructor or contact help@playposit.com.',
			  			buttons,
			  		},
			  		timeout: 0,
			  	});
			  }
      }
		},
		// -- INSTRUCTOR SIDE -- detect interaction id change on player and update on firestore
		'activeInteraction'(n, o) {
			if(!_.isEqual(n, o)) {
				if(this.isBroadcast && this.user.userType === 'teacher') {
					console.log('activeInteraction:: ', n, o);
					if(n !== null) {
						// -- trigger on question open
						triggerInteractionItems(this.broadcastId, this.displayTime, this.activeInteraction.id);
					}
					else {
						// -- trigger on question close
						triggerInteractionItems(this.broadcastId, this.displayTime, null);
					}
				}
			}
		},
		// -- STUDENT SIDE -- detect interaction id change on firestore and trigger for student
		'broadcastActiveInteractionId'(n, o) {
			console.log('broadcastActiveInteractionId:: ', n, o);
			if(!_.isEqual(n, o)) {
				console.log('broadcastActiveInteractionId:: ', this.isBroadcast, this.user.userType);
				if(this.isBroadcast && this.user.userType === 'student') {
					if(null === n) {
						console.log('broadcastActiveInteractionId:: ', n);
						this.requestSetActiveInteraction(null);
					}
					else {
						if (!this.activeInteractionGroup.length) {
							this.buildActiveGroup();
							if (this.hasNewInteractionDisplayAccess) this.setInteractionStates();
						}
						const activeInteraction = _.filter(this.activeInteractionGroup, i => {
							return i.interaction && i.interaction.id === this.broadcastActiveInteractionId;
						});

						console.log('activeInteraction:: ', activeInteraction);
						if(activeInteraction && activeInteraction.length > 0) {
							this.requestSetActiveInteraction(activeInteraction[0].interaction);
						}
						else {
							console.error('ERROR:: Interaction not found.', this.broadcastActiveInteractionId, activeInteraction);
						}
					}
				}
			}
		},
		// -- STUDENT SIDE -- detect displayTime change on firestore and trigger for student
		'broadcastDisplayTime'(n, o) {
			console.log('broadcastDisplayTime:: ', n, o);
			if(!_.isEqual(n, o)) {
				if(this.isBroadcast && this.user.userType === 'student') {
					this.setDisplayTime(this.broadcastDisplayTime);
				}
			}
		},
		'youTubePlayClicked' (n, o) {
			if (n && !o) this.initializePlay();
		},
		panoptoInitialized(newValue, oldValue) {
			if (newValue) {
				this.checkResumeWhereLeftOff();
			}
		},
		playerControlsDisplayType(newValue, oldValue) {
			if (newValue && newValue.toLowerCase() === 'fade') {
				this.$refs.controlsWrapper.style.setProperty('opacity', 0);
			}
		},
		async requiredMaxTime(newValue) {
			/*
				If there's a required interaction located at 00:00, the displayTime watcher won't fire because the displayTime never changes from 0. The following code ensures that such interactions still get the same treatment that they would from that displayTime watcher, which mainly involve properly making them active in the sidebar.
			*/
			if (newValue < 1) {
				this.buildActiveGroup();
				await this.$nextTick();
				if (this.hasNewInteractionDisplayAccess) {
					// Update the states for all interactions.
					this.setInteractionStates();
				}
			}
		},
  },
  created() {
		// Setting up namespaced debugging object for our BulbControls Vue component
		window.PP.BulbControls = {
			vm: this,
			dynamicallyAddedHasNewInteractionDisplayAccessFeatureFlag: false,
		};
		this.handleWindowUnloadEvent();
  },
	async beforeDestroy() {
		await this.bulbControlsBroadcastChannel.close();
	},
  mounted() {
		this.initializeBulbControlsBroadcastChannel();
		this.resetInactivityTimer();
		this.initCheckoutTimer();
 		this.initializeMaxTime();
		this.buildInteractionGroups(this.interactions);
		
		// Commenting out due to issues with new interaction display logic and interactions at 0th timestamp.
		// this.inspectBulbInteractionDensity;

		if (_.has(this.bulb, 'config.classes')) this.attachBulbClasses(this.bulb)

		if (this.bulbAttempt.complete) this.openTab('bulb-info-tab');

		if (this.isBroadcast) {
			if(this.queryParams.has('code')) {
				if (_.get(this, 'bulb.bulbSectionId')) {
					const bulbBroadcastCode = btoa(_.get(this, 'bulb.bulbSectionId'));
					if (this.queryParams.get('code') !== bulbBroadcastCode) this.setBroadcastId(bulbBroadcastCode);
					else this.setBroadcastId(this.queryParams.get('code'));
				}
			}
			else if (_.get(this, 'bulb.bulbSectionId')) {
				this.setBroadcastId(btoa(_.get(this, 'bulb.bulbSectionId')));
			}
			else return alert('Invalid broadcast session. Code not found.');

			listenBroadcastEvents(this.broadcastId, this.user.userType, this.broadcastEventListeners);
			if(this.user && this.user.userType === 'teacher') triggerInstructorStatus(this.broadcastId, 'online');
			else if(this.user && this.user.userType === 'student') {
				if (this.user.firstName !== 'FirstName' && this.user.lastName !== 'LastName') triggerLearnerStatus(this.broadcastId, this.user.id, this.bulbAttempt.id, 'online');
			}
		}

		this.fullscreenToast();
		EventBus.$on('requestAction', key => {
			this.handleVideoContainerRequestActionClassState(key);
			EventBus.$emit('transferActionRequest', key);
		});
		EventBus.$on('requestPlay', (request) => {
			this.requestPlay()
		});
		EventBus.$on('replayVideo', () => {
			this.replayVideo();
		});
		EventBus.$on('toggle-player-sidezone', () => {
			this.toggleSidezone();
		});
		EventBus.$on('toggle-player-settings-menu', () => {
			this.toggleSettings();
		});
		this.setSessionStartTime(moment());
		this.setSessionId();
		this.setPreviousSessionTime(this.bulbAttempt.timeElapsed);
		if (this.screenfull?.isEnabled) {
			this.screenfull.on('error', event => {
				console.log('PlayPosit error - failed to enable fullscreen', event);
			});
		}
		// if (this.isVimeoPasswordProtectedVideo) {
		// 	this.handleVimeoPasswordProtectedVideoPreloader();
		// }
  },
};
</script>

<style>
	.clearfix:after {
		content:".";
		display:block;
		height:0;
		clear:both;
		visibility:hidden;
	}

	.flip-vertically {
		transform: rotate(180deg);
	}
	.no-current{
		width: 100%;
	  padding-bottom: 54.25%;
	}
	#mimic {
		position: relative;
		z-index: 1;
	}

	#player-thumbnail {
		position: absolute;
		top:0; left:0; right:0; bottom:0;
	}
	#liveSessionThumbnail{
		position: absolute;
		top:0; left:-22px; right:0; bottom:0;
	}
	#player-container{
		position:absolute;
		flex-direction:row;
		height: 100%;
		width:100%;
		background: black;
	}
	#player-container.desktop,
	#player-container.landscape,
	#player-container.portrait{
		display: flex;
	}
	#video-container{
		position: relative;
		flex: 1;
		display: flex;
    flex-direction: column;
    justify-content: center;
    transition: left .4s cubic-bezier(0.4, 0, 0.2, 1);
	}
  #posit-wrapper{
  	position: relative;
    max-width: 177.78vh;
    margin: 0 auto;
    width: 100%;
    max-height: 100%;
  }
  #posit-wrapper.small-aspect-ratio {
  	max-width: 147.78vh !important;
  }

  #controls-wrapper {
  	display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 0px;
    align-items: center;

  	position: absolute;
		opacity: 1;
		transition: opacity 150ms ease-in-out;
		left:0;
		right:0;
		z-index: 35;

		background: linear-gradient(0deg, rgba(0, 0, 0, 0.25), transparent);
		/*padding-left: 55px;*/
		bottom: 0;
  }

	/* paused state */
	#video-container.pause + #controls-wrapper {
		opacity: 1 !important;
	}

	#controls-wrapper #play-pause, #controls-wrapper #bulb-replay {
		height: 50px;
		width: 55px;
	}

	#controls-wrapper #play-pause i, #controls-wrapper #bulb-replay i {
		font-size: 2.5em;
	}

	.control-wrapper-icon,
	#toggle-sidebar,
	#toggle-settings {
		position: relative;
		width: 50px;
		height: 50px;
	}
	.control-wrapper-icon:hover,
	#toggle-sidebar:hover,
	#toggle-settings:hover {
  	cursor:pointer;
  }
  .control-wrapper-icon i,
  #toggle-sidebar i,
  #toggle-settings i {
    font-size: 2em;
  }

	.sidebar-slide-enter-active {
	  overflow: hidden;
	}
	.sidebar-slide-leave-active {
	  overflow: hidden;
	 	background-color: #eceff1 !important;
	}


	.noUi-target {
    background: #fff;
    border-radius: 19px;
    border: 1px solid #D3D3D3;
    border: none !important;
	}

	.noUi-base{
		background: grey;
	}
	/*.noUi-connect:nth-child(1) {*/
		/* 0 to display_time */
	/*	background-color: var(--branding-active-hex) !important;*/
	/*	background-color: #0000FF;*/
	/*}*/
	.noUi-connect:nth-child(2) {
		/* display_time to max_display_time*/
		background:white;
	}
	.noUi-origin:nth-child(2){
		/* handle for display_time*/
    display:none;
    pointer-events: none;
	}
	.noUi-origin:nth-child(4) {
		/* handle for max_display_time */
		display:none;
		pointer-events: none;
	}

	.noUi-horizontal {
	    height: 16px;
	    margin: 0 15px;
	}
	.noUi-horizontal .noUi-handle {
	    width: 25px;
	    height: 25px;
	    left: -17px;
	    top: -5px;
	    /* border-color: #0181e7; */
	    border: solid 2px #0181e7;
	    border-radius: 25px;
	}

	.noUi-connect {
	    background: #2196f3;
	    border-radius: 19px;
	    transition: background 450ms;
	}
	.noUi-handle::after, .noUi-handle::before {
	    content: none !important;
	}

  .noUi-horizontal.thin {
		height: 3px;
	}

	.noUi-horizontal.thin .noUi-handle {
		width: 15px;
		height: 15px;
		padding: 10px;
		border:none;
		left:0;
		top: -9px;
		box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
		cursor: pointer;
		transform: scale(1);
		transition: transform 150ms ease-in-out;
	}

	.noUi-horizontal.thin .noUi-handle:hover {
		transform: scale(1.3);
	}
	
	.noUi-tooltip {
    display: none;
	}
	.noUi-active .noUi-tooltip {
	    display: block;
	}
  .split.split-horizontal{
    height: 100%;
    /*border-radius: 4px;*/
    float: left !important;
  }

  #player-container.portrait {
		flex-flow: row wrap;
  }
  .allow-overlay, #player-container.landscape #video-container{
  	position: absolute !important;
  	/* [ ] find what to not use hard coded values for offset */
  	left: 0;
  	right: 0;
    top: 0;
    bottom: 0;
  }

  .allow-overlay, #player-container.sidezone-open.landscape #video-container {
    left: 55px;
  }
  #player-container.uninitialized {
  	z-index: 0;
  }
  #player-container.portrait.uninitialized {
  	position: absolute !important;
  	left: -999999px;
  	z-index: -99999;
  }

#player-container.portrait.uninitialized.exposeYouTubeControls {
  	position: unset !important;
  	left: unset;
  	z-index: unset;
		align-items: center;
  }

  #player-container.portrait #video-container {
  	order: 1; /* make the video container appear first */
  	flex-basis: 100%; /* set to 100% width, this causes line break for other two divs*/
  	height:	56.54vw; /* limit height to maintain 16:9 aspect ration */
  }
	#player-container.portrait #controls-wrapper {
		background: none;
		bottom: revert;
  }
  #player-container.portrait #nav-margin {
  	/* reposition nav-margin to second item in row, fill all vertical space not taken by video */
  	order: 2;
  	height: calc(100% - 56.54vw);
  }
  #player-container.portrait #sidebar-panel{
  	/* reposition the sidebar-container to 3rd item in row on left side, fill horizontal space not taken up by nav-margin */
  	order: 3;
  	flex-basis: 0;
  	flex-grow: 1;
  	height: calc(100% - 46.54vw);
  	flex-basis: calc(100% - 55px);
    transform: translate(0);
    position: relative;
    width:300px;
		background-color: white !important;
  }

	#player-container.portrait #sidebar-panel .review-wrapper, #player-container.portrait #sidebar-panel .interactions-wrapper {
		margin-top: 43px;
	}

	#player-container.portrait #nav-margin #bulb-actions .logo {
		margin-top: 48px;
  }

	#player-container.portrait #wrapper, #player-container.portrait #question-timeline {
  	top: 123px !important;
  }

	#player-container.portrait.broadcast--student > #sidebar-panel, #player-container.portrait.broadcast--student > #nav-margin {
		order: 1;
  }
	
  #player-container.portrait #sidebar-container #minimize, #player-container.portrait #sidebar-container #maximize{
  	/* sidebar-container will always be visible in portrait mode, hide the minimize and maximize buttons on the nav */
  	display: none;
  }

	#settings-menu-dialog-tooltip.portrait .settings-menu.v-dialog {
		/* The settings menu dialog displays differently in portrait mode, below the scrub bar. */
		bottom: 0;
  }

  .collection-item i{
  	line-height: 0.9em;
    vertical-align: middle;
    margin-right: 5px
  }

  #initialize-play {
  	height: 100px;
    max-width: 224px;
   	flex-direction: column;
  }
  /*#initialize-play:hover{*/
  /*		opacity: .8; }*/
  #initialize-play i{	font-size: 5em; }

  .arrow-right {
	  width: 0;
	  height: 0;
	  border-top: 30px solid transparent;
	  border-bottom: 30px solid transparent;
	  border-left: 50px solid white;
	  margin: 0 auto;
	}

	.interaction-dot {
		height: 7px;
		width: 7px;
		background: white;
		position: absolute;
		bottom: -2px;
		z-index: 5;
		border-radius: 50%;
		box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.14);
		cursor: pointer;
	}

	.interaction-dot:hover .interaction-preview-block {
		visibility: visible;
	}

	.interaction-dot:hover .interaction-preview {
		opacity: 1;
	}

@media screen and (min-width: 0px) and (max-width: 480px) {
  #initialize-play {
    height: 40px;
    min-width: 56px;
    width: 56px;
  }
  #initialize-play i {
  	font-size: 2em;
  }
  #initialize-play .v-progress-circular {
  	width: 20px !important;
  	height: 20px !important;
  }

  .v-snack__content {
  		padding: 5px !important;
    	font-size: 12px !important ;
	 }

  #sidebar-panel {
 		max-width: calc(100% - 40px) !important;
  }
 	#sidebar-panel .sidebar-tab, #sidebar-actions i {
 		font-size: 14px !important;
 	}

 .landscape #sidebar-panel.open {
    left: 40px !important;
	}

	#resize-side-panel {
		display: none !important;
	}

  #sidebar-panel .sidebar-tabs {
    min-height: 24px !important;
  }
  #sidebar-panel .sidebar-tabs i {
    display: none;
  }

  #sidebar-panel .review-wrapper, #sidebar-panel .interactions-wrapper {
  	margin-bottom: 40px !important;
  }

  #nav-margin {
  	min-width: 0px !important;
  	width: 40px !important;
  }
  #bulb-actions .logo {
    height: 36px;
  }
  #toggle-sidepanel button {
    width: 40px !important;
    height: 40px !important;
  }
  #wrapper, #question-timeline {
  	top: 95px;
  	bottom: 80px !important;
  }
  span .marker {
  	padding: 0 !important;
  }
  .marker::after {
    left: 32px !important;
  }

  .toggle-side-panel {
  	padding: 0 !important;
  }
  .toggle-side-panel button {
  	margin: 0;
  }

	#controls-wrapper #play-pause, #controls-wrapper #bulb-replay {
		height: 40px;
    width: 40px;
	}
	.control-wrapper-icon, #toggle-sidebar, #toggle-settings {
    position: relative;
    width: 25px;
    height: 25px;
    margin: 0;
    margin: 0 10px;
	}
	.runtime {
		bottom: 40px !important;
	}
	.runtime span {
  	font-size: 12px !important;
  }
	#controls-wrapper #play-pause i, #controls-wrapper #bulb-replay i, .control-wrapper-icon i, #toggle-sidebar i, #toggle-settings i {
  	font-size: 24px;
  }

  .control-wrapper-icon, #toggle-sidebar, #toggle-settings {
  	width: 25px;
    height: 25px;
  }

  .allow-overlay, #player-container.sidezone-open.landscape #video-container {
  	left: 40px;

  }

  .settings-menu.v-dialog {
  	right: 0;
    width: 100%;
  }

  .custom-select {
  	font-size: 12px;
  }

}

@media screen and (max-width: 480px) {
  .v-snack__content {
  	padding: 10px !important;
  }
}

@media screen and (min-width: 0px) and (max-width: 320px) {

}
@media screen and (min-width: 321px) and (max-width: 480px) {
  #initialize-play {
    height: 60px;
    min-width: 84px;
    width: 84;
  }
  #initialize-play i {
  	font-size: 3em;
  }
  #initialize-play .v-progress-circular {
  	width: 20px !important;
  	height: 20px !important;
  }
}
@media screen and (min-width: 481px) and (max-width: 768px) {

}
@media screen and (min-width: 768px) and (max-width: 1024px) {

	#player-container.portrait #wrapper, #player-container.portrait #question-timeline {
		top: 170px !important;
  }

}
@media screen and (min-width: 1025px) {

}
#mimic-broadcast-teacher, #mimic-broadcast-student {
	position: absolute;
	height:100%;
	width: calc(100% - 480px);
	margin-left: 480px;
	z-index: 9;
}
#player-mimic-broadcast { width: 80%; }
@media only screen and (max-width: 600px) {
	#player-mimic-broadcast { width: auto; }
}
#player-mimic-broadcast span.text-bold { font-weight: bold; }
#player-mimic-broadcast #initialize-broadcast {
	opacity: 0.8;
	background-color: #1B5E20 !important;
	flex-direction: column;
}
#player-mimic-broadcast #initialize-broadcast:hover { opacity: 1; }
@media only screen and (min-width: 320px) and (max-width: 959px) {
	#mimic-broadcast-teacher, #mimic-broadcast-student {
		width: 100%;
		margin-left: 0;
	}
	#player-mimic-broadcast { width: 100%; }
	#mimic-broadcast-student { display: none; }
	.broadcast--student > #nav-margin { height: 100% !important; }
	.broadcast--student > #sidebar-panel { height: 100% !important; }
	.broadcast--student.uninitialized {
		left: 0 !important;
		z-index: 1 !important;
	}
}
.enterLesson {
	opacity: 0.9
}
.hideVideoInstance {
	position: absolute !important;
}
.hidePlayerContainer {
	visibility: hidden;
}
#liveSessionMimic {
	position: absolute;
  z-index: 36;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
#enterSessionButton {
	color: var(--branding-active-hex);
}

.hideAriaLabel {
  display: none !important;
}

#panopto-mobileIOS-information-icon {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 44px;
	height: 44px;
}

#player-confetti-container {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  z-index: 99999999999;
  pointer-events: none;
}

.vimeo-password-protected-wrapper {
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
}

.vimeo-password-protected-custom-player-preloader {
	width: 411px !important;
	height: 411px !important;
}

@media screen and (min-width: 321px) and (max-width: 480px) {
	.vimeo-password-protected-wrapper.portrait.mobile #password-protected-vimeo-video > svg {
		width: 359px !important;
		height: 359px !important;
	}
}

@media screen and (min-width: 768px) and (max-width: 980px) {
	.vimeo-password-protected-wrapper.desktop #password-protected-vimeo-video > svg {
		width: 227px !important;
		height: 227px !important;
	}

}

@media screen and (min-width: 768px) and (max-width: 1024px) {
	.vimeo-password-protected-wrapper.portrait.mobile #password-protected-vimeo-video > svg {
		width: 459px !important;
		height: 459px !important;
	}
}

</style>
